export type EnvConfigResponse = {
  flags: EnvConfigFlags;
  hostUrl: string;
};

export type EnvConfigFlags = {
  newSubmissionStatus: boolean;
  createContactNoteNewUiEnabled?: boolean;
  dropdownApi: boolean;
  auditApiEnabled: boolean;
  qualifiedContactApiEnabled: boolean;
  createNotePublicApi: boolean;
  useAgGridV2HomeSearch: boolean;
  enablePshApiUpdate: boolean;
  enableBrClientRepresentativeTable: boolean;
  tripIdWildcardSearch: boolean;
};

export type EnvConfigProps = EnvConfigFlags & {
  hostUrl: string;
};

let _config: EnvConfigProps;

_config = {
  newSubmissionStatus: false,
  createContactNoteNewUiEnabled: true,
  dropdownApi: false,
  auditApiEnabled: false,
  qualifiedContactApiEnabled: false,
  createNotePublicApi: false,
  useAgGridV2HomeSearch: false,
  hostUrl: '',
  enablePshApiUpdate: false,
  enableBrClientRepresentativeTable: true,
  tripIdWildcardSearch: false,
};
// eslint-disable-next-line unicorn/no-static-only-class
export class EnvConfig {
  static get config() {
    return _config;
  }

  static set config(value: EnvConfigProps) {
    _config = value;
  }
}
